export default {
  translation: {
    regionPicker: {
      chooseArea: 'Choose your area'
    },
    configurator: {
      configureNow: 'Configure my handle !',
      chooseFrameColor: 'Choose your frame color bellow',
      chooseHandle: 'Choose your prefered handle bellow',
      createYourOwnButton: 'Create your own design',
      createYourOwn: 'Upload your design',
      sendConfig: 'Save this handle',
      colorType: {
        ral: 'Lacquered',
        anodized: 'Anodized',
        decor: 'Decorative',
        custom: 'Custom'
      },
      color: {
        black: 'Black',
        white: 'White'
      },
      form: {
        myConfig: 'Save my custom handle',
        send: 'Send!',
        success: 'Your configuration has been successfully sent by e-mail!',
        error: 'An error occurred while sending you an e-mail!',
        model: 'Handle model',
        color: 'Color',
        ornament: 'Decor',
        ornament_color: 'Decor\'s color',
        custom: 'Custom decor'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/i18n/en.js